

module.exports = __webpack_require__.stylable.create(
    "InfoIcon70967723",
    {"classes":{"root":"InfoIcon70967723__root","icon":"InfoIcon70967723__icon"},"vars":{},"stVars":{},"keyframes":{}},
    ".InfoIcon70967723__root{display:inline-block;line-height:0;color:var(--wsr-color-10, #3899EC)}.InfoIcon70967723__icon{vertical-align:middle}",
    2,
    "InfoIcon70967723",
    __webpack_require__.stylable.$
);
